import axios from '../base/axios';
import API_KEY from './key';

const GET_SCIENCEFICTION = 'flixfrenzy/redux/GET_SCIENCEFICTION';

// eslint-disable-next-line default-param-last
const scienceFictionReducer = (state = [], action) => {
  switch (action.type) {
    case GET_SCIENCEFICTION:
      return action.payload;
    default:
      return state;
  }
};

export const getScienceFiction = () => (dispatch) => {
  axios.get(`discover/movie?api_key=${API_KEY}&with_genres=878`).then((res) => {
    dispatch({
      type: GET_SCIENCEFICTION,
      payload: res.data,
    });
  });
};

export default scienceFictionReducer;
